// extracted by mini-css-extract-plugin
export default {"container":"oIaYo6","oneColumn":"kUYAww","twoColumns":"Nu850o","threeColumns":"bEH8kO"};